import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { LoaderCircle } from 'lucide-react';
import { useAuth } from '@/auth/AuthProvider';

/**
 * Route guard. Renders the nested routes when signed in, a splash while the session is being
 * restored, and redirects to /login (remembering the target) otherwise.
 */
export function RequireAuth({ children }: { children?: React.ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div
        className="flex min-h-screen items-center justify-center text-muted-foreground"
        role="status"
        aria-live="polite"
      >
        <LoaderCircle className="mr-2 h-5 w-5 animate-spin" aria-hidden="true" />
        Loading…
      </div>
    );
  }
  if (status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return children ? <>{children}</> : <Outlet />;
}
